import Link from "next/link";
import React, { useState } from "react";
import helper from "../../lib/helper";
import homepagelayoutModel from "../../models/homepagelayout.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "react-bootstrap/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);
  const [swappedItems, setSwappedItems] = useState([]);
  const [isReorderMode, setIsReorderMode] = useState(false); // ✅ toggle state

  const router = useRouter();
  const queryParams = router.query;

  const {
    data: homepagelayoutData,
    mutate: reloadhomepagelayoutData,
    isLoading,
  } = useSWR(
    queryParams || null,
    () => homepagelayoutModel.list(queryParams),
    config.swrConfig
  );

  const confirmDelete = async (id, title) => {
    await helper.sweetalert
      .confirm(`confirm to delete ${title}`, "warning")
      .then(async (result) => {
        if (result.isConfirmed) {
          setShowLoader(true);
          await homepagelayoutModel.destroy(id).then(() => {
            reloadhomepagelayoutData();
            helper.sweetalert.toast(`${title} deleted Successfully`);
          });
          setShowLoader(false);
        }
      });
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const items = Array.from(homepagelayoutData.data);

    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    const updatedItems = items.map((item, index) => ({
      ...item,
      sort_index: index,
    }));

    const payload = updatedItems.map((item) => ({
      id: item.id,
      sort_index: item.sort_index,
    }));

    reloadhomepagelayoutData(
      { ...homepagelayoutData, data: updatedItems },
      false
    );
    setSwappedItems(payload);

    try {
      await homepagelayoutModel.updatepositionshomepage(JSON.stringify(payload));
      helper.sweetalert.toast("Positions updated!");
    } catch (err) {
      console.error("Error updating positions:", err);
      helper.sweetalert.toast("Failed to update positions", "error");
    }
  };

  return (
    <>
      <Heading title="Homepagelayout" showLoader={isLoading || showLoader}>
        <Link className="btn btn-primary btn-sm" href="/homepagelayout/create">
          <i className="bi bi-plus" /> Create
        </Link>
        <button
          className="btn btn-secondary btn-sm mx-2"
          onClick={() => setIsReorderMode(!isReorderMode)}
        >
          {isReorderMode ? "Disable Reorder" : "Enable Reorder"}
        </button>
      </Heading>

      <div className="container-fluid">
        <div className="card">
          <div className="card-header">layout-list</div>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="layout-table">
              {(provided) => (
                <Table
                  striped
                  bordered
                  hover
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Type</th>
                      <th>Content Type</th>
                      <th>Date</th>
                      <th>Position</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {homepagelayoutData?.data?.map((row, index) => (
                      <Draggable
                        key={row.id}
                        draggableId={row.id.toString()}
                        index={index}
                        isDragDisabled={!isReorderMode} // ✅ disable if toggle off
                      >
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <td>{row.title}</td>
                            <td>{row.type}</td>
                            <td>{row.content_type}</td>
                            <td>{helper.date.format(row.created_at)}</td>
                            <td>{row.sort_index}</td>
                            <td>
                              <div className="btn-group btn-group-sm">
                                <Link
                                  className="btn btn-primary"
                                  href={`/homepagelayout/${row.id}/content`}
                                >
                                  <i className="bi bi-eye"></i>
                                </Link>
                                <Link
                                  className="btn btn-warning"
                                  href={`/homepagelayout/${row.id}/edit`}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </Link>
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    confirmDelete(row.id, row.title)
                                  }
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </tbody>
                </Table>
              )}
            </Droppable>
          </DragDropContext>

          <div className="card-footer">
            <Pagination meta={homepagelayoutData?.meta} />
          </div>
        </div>

       
      </div>
    </>
  );
};

export default Page;
